import React from 'react';
import { Calendar, Users } from 'lucide-react';
export function TeamCalendarWidget() {
  // Mock data - simplified week view
  const days = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven'];
  const teamMembers = [{
    id: 1,
    name: 'Marie Dupont',
    avatar: 'MD',
    absences: [false, true, true, false, false]
  }, {
    id: 2,
    name: 'Jean Martin',
    avatar: 'JM',
    absences: [false, false, false, true, true]
  }, {
    id: 3,
    name: 'Sophie Bernard',
    avatar: 'SB',
    absences: [true, false, false, false, false]
  }, {
    id: 4,
    name: 'Thomas Petit',
    avatar: 'TP',
    absences: [false, false, false, false, false]
  }, {
    id: 5,
    name: 'Camille Roux',
    avatar: 'CR',
    absences: [false, false, true, true, false]
  }];
  return <div className="bg-white rounded-lg shadow-sm p-5 col-span-1" data-id="element-2107">
      <div className="flex items-center justify-between mb-4" data-id="element-2108">
        <h3 className="font-semibold text-gray-900" data-id="element-2109">Calendrier d'équipe</h3>
        <div className="flex space-x-2" data-id="element-2110">
          <Calendar className="h-5 w-5 text-blue-600" data-id="element-2111" />
          <Users className="h-5 w-5 text-blue-600" data-id="element-2112" />
        </div>
      </div>
      <div className="overflow-x-auto" data-id="element-2113">
        <table className="min-w-full" data-id="element-2114">
          <thead data-id="element-2115">
            <tr data-id="element-2116">
              <th className="px-2 py-2 text-left text-xs font-medium text-gray-500" data-id="element-2117">
                Employé
              </th>
              {days.map((day, index) => <th key={index} className="px-2 py-2 text-center text-xs font-medium text-gray-500" data-id="element-2118">
                  {day}
                </th>)}
            </tr>
          </thead>
          <tbody data-id="element-2119">
            {teamMembers.map(member => <tr key={member.id} data-id="element-2120">
                <td className="px-2 py-2 whitespace-nowrap" data-id="element-2121">
                  <div className="flex items-center" data-id="element-2122">
                    <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-800 font-medium text-sm" data-id="element-2123">
                      {member.avatar}
                    </div>
                    <span className="ml-2 text-sm text-gray-900" data-id="element-2124">
                      {member.name}
                    </span>
                  </div>
                </td>
                {member.absences.map((isAbsent, index) => <td key={index} className="px-2 py-2 text-center" data-id="element-2125">
                    {isAbsent ? <div className="h-6 w-6 bg-red-100 rounded-md mx-auto" data-id="element-2126"></div> : null}
                  </td>)}
              </tr>)}
          </tbody>
        </table>
      </div>
      <div className="mt-4 text-right" data-id="element-2127">
        <button className="text-blue-600 text-sm font-medium hover:text-blue-800" data-id="element-2128">
          Voir calendrier complet
        </button>
      </div>
    </div>;
}